// adminApi.js
import axios from "axios";

const FRYMES_ORDER_API_SERVICE = `${process.env.REACT_APP_API_URL}/adminservice/api/frymeOrder`;

const apiClient = axios.create({
  baseURL: FRYMES_ORDER_API_SERVICE,
  withCredentials: true,
});

const frymesOrderApi = {
  saveFrymeRequest: (payload) => apiClient.post("/create", payload),

  getRequestOfMA( status,page, pageSize, sortedColumn, sortOrder) {
    return apiClient.get("/requestsOfMA", {
      params: { status, page, pageSize, sortedColumn, sortOrder },
    });
  },

  approveRequest: (id) => apiClient.put(`/${id}/approve`),

  rejectRequest: (id) => apiClient.put(`/${id}/reject`),

  getLedger ( email) {
        return apiClient.get("/ledger", {
          params: { email },
        });
      },

  getRequestsOfFA1( email,status,page, pageSize, sortedColumn, sortOrder) {
    return apiClient.get("/requestsOfFA1", {
      params: { email, status, page, pageSize, sortedColumn, sortOrder },
    });
  }, 
  
  getCountOfSoldFrymesByMA: () => apiClient.get("/totalQuantity", {
  }),

  getLast5RequestsOfMA:() =>apiClient.get("/last5-requests", {
  }),

  getTotalFrymesBoughtByFranchise: (email) => apiClient.get("/totalBoughtQuantity", {
    params: { email },
  }),
  getTotalFrymesSoldByFranchise: (email) => apiClient.get("/totalSoldQuantity", {
    params: { email },
  }),

  getLast3RequestByFranchise: (email) => apiClient.get("/last3RequestsByFranchise", {
    params: { email },
  }),
};

export default frymesOrderApi;
